<template>
    <div class="bg-gradient-to-b from-carbon-100 to-carbon-200 lg:py-12 lg:px-16 p-6 rounded-lg dark-shadow">
        <slot></slot>
    </div>
</template>